import { COPY_NOTIFICATION_DURATION } from '@/common/constants/notifications.constants';
import { NotificationType } from '@/common/constants/common.constants';
import { useClipboard } from '@vueuse/core';
import { useNotifications } from '@/common/utils/notifications/notificationsPlugin';
import { computed } from 'vue';
import { useI18n } from '@/common/composables/vue-i18n.composable';
import { toString } from 'lodash-es';
import { ElNotification } from '@uikit/ui-kit/types/notification';

type Props = {
  showNotification?: boolean;
  icon?: string;
};

const useCopy = (props: Props = {}) => {
  const {
    showNotification = true,
    icon = ''
  } = props;

  const { notify } = useNotifications();
  const { copy, copied } = useClipboard({ copiedDuring: COPY_NOTIFICATION_DURATION });
  const { t } = useI18n();

  const copyIcon = computed(() => copied.value ? 'i-check--16' : icon);

  async function copyText(text: string|number, notificationMessage?: string) {
    await copy(toString(text));

    if (showNotification) {
      (notify as ElNotification)({
        type: NotificationType.SUCCESS,
        message: notificationMessage || t('Copied to clipboard'),
        showClose: false,
        duration: COPY_NOTIFICATION_DURATION,
        skipStore: true
      });
    }
  }

  return {
    copyText,
    copyIcon
  };
};

export default useCopy;
